/** A ghost icon button that explains itself on hover. */

import type { ReactNode } from "react";
import { Button } from "./ui/button.tsx";
import { Tooltip, TooltipContent, TooltipTrigger } from "./ui/tooltip.tsx";
import { cn } from "../lib/utils.ts";

interface IconActionProps {
  /** Serves as both the tooltip and the accessible name — they must not drift. */
  readonly label: string;
  readonly onClick: () => void;
  readonly children: ReactNode;
  readonly className?: string;
  readonly side?: "top" | "right" | "bottom" | "left";
}

export function IconAction({
  label,
  onClick,
  children,
  className,
  side = "bottom",
}: IconActionProps) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          variant="ghost"
          size="icon-sm"
          onClick={onClick}
          aria-label={label}
          className={cn(
            "shrink-0 text-muted-foreground hover:text-sidebar-foreground",
            className,
          )}
        >
          {children}
        </Button>
      </TooltipTrigger>
      <TooltipContent side={side}>{label}</TooltipContent>
    </Tooltip>
  );
}
